import React from 'react'
import { useStoreState } from '@mortgage-pos/ui/store'
import PhoneIcon from '@mortgage-pos/ui/assets/PhoneIcon.svg'
import EmailIcon from '@mortgage-pos/ui/assets/EmailIcon.png'
import { formatPhoneNumber } from '@mortgage-pos/utils'
import { popupCalendlyWidget } from '@shared-fe/utils/calendly'

export const LoanOfficerNavCard = () => {
  const { loanOfficer } = useStoreState((state) => state.loanOfficer)

  if (!loanOfficer) {
    return <></>
  }

  const phoneNumber = loanOfficer?.phone
    ? formatPhoneNumber(loanOfficer.phone)
    : ''

  return (
    <div className="loan-officer-nav-card" data-testid="loan-officer-nav-card">
      {loanOfficer.headshot ? (
        <img
          src={loanOfficer.headshot}
          className="loan-officer-nav-card__headshot"
          alt={`${loanOfficer.name} headshot`}
        />
      ) : null}

      <p className="loan-officer-nav-card__name">{loanOfficer.name}</p>
      <p className="loan-officer-nav-card__title">
        {loanOfficer.nmls
          ? 'Mortgage Loan Originator'
          : 'Client Care Specialist'}
      </p>
      <p className="loan-officer-nav-card__nmls">
        {loanOfficer.nmls ? `NMLS #${loanOfficer.nmls}` : null}
      </p>

      <div className="loan-officer-nav-card__contact">
        <img
          className="loan-officer-nav-card__contact-icon"
          src={EmailIcon}
          alt="email-icon"
        />
        <a
          href={`mailto: ${loanOfficer?.email}`}
          className="loan-officer-nav-card__contact-button"
        >
          {' '}
          {loanOfficer.email}
        </a>
      </div>
      <div className="loan-officer-nav-card__contact">
        <img
          className="loan-officer-nav-card__contact-icon"
          src={PhoneIcon}
          alt="phone-icon"
        />
        {phoneNumber}
      </div>
      {loanOfficer.calendly_link ? (
        <div className="loan-officer-card__contact">
          <span
            onClick={() => popupCalendlyWidget(loanOfficer.calendly_link)}
            className="loan-officer-nav-card__calendly"
          >
            Schedule time to chat
          </span>
        </div>
      ) : null}
    </div>
  )
}
